import React from 'react';
import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Flex minH="100vh" align="center" justify="center" bg="surface.canvas" p="24px">
      <Box
        maxW="420px"
        w="full"
        p="32px"
        textAlign="center"
        bg="surface.base"
        borderRadius="xl"
        boxShadow="card"
      >
        <Text fontFamily="mono" fontSize="12px" color="content.faint">
          404
        </Text>
        <Heading
          as="h1"
          mt="8px"
          fontFamily="display"
          fontSize="24px"
          lineHeight="30px"
          fontWeight={500}
          color="content.strong"
        >
          Página não encontrada
        </Heading>
        <Text mt="8px" fontSize="13px" lineHeight="20px" color="content.body">
          O endereço acessado não existe ou foi movido.
        </Text>
        <Flex mt="24px" gap="8px" justify="center">
          <Button variant="outline" onClick={() => navigate(-1)}>
            Voltar
          </Button>
          <Button onClick={() => navigate('/')}>Ir para o painel</Button>
        </Flex>
      </Box>
    </Flex>
  );
}
